import { DS_FONT_SIZE } from '@calm/evexia-design-tokens';
import CHLink from '@rhg/components/ch-link';
import registrationMessages from '@rhg/lang/messages/registration';
import { Stack, Box, Typography } from '@rhg/libs/material';
import { WarningWithCircleBackgroundWhite } from '@rhg/libs/material/icons/warning-with-circle-background-white';
import { calmSupportEmail } from '@rhg/utils/constants';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

const wrapper = {
    pt: 12,
};

const descriptionBox = {
    width: { xs: '85%', md: '40%' },
};

const mobileHeadingStyle = {
    mb: 4,
    fontSize: { xs: DS_FONT_SIZE.H5, md: DS_FONT_SIZE.H4 },
};

const mobileTextStyle = {
    fontSize: { xs: DS_FONT_SIZE.NORMAL_MEDIUM, md: DS_FONT_SIZE.NORMAL_LARGE },
};

function SsoSponsorshipError() {
    const { formatMessage } = useIntl();

    return (
        <Stack sx={wrapper} alignItems="center" gap={4}>
            <WarningWithCircleBackgroundWhite sx={{ mt: 12 }} />
            <Box sx={descriptionBox}>
                <Typography
                    color="text.body"
                    align="center"
                    variant="h4"
                    component="h1"
                    sx={mobileHeadingStyle}
                >
                    {formatMessage(
                        registrationMessages[
                            'registration.join_sponsorship_failure.header'
                        ]
                    )}
                </Typography>
                <Typography
                    color="text.body"
                    align="center"
                    paragraph
                    sx={mobileTextStyle}
                >
                    {formatMessage(
                        registrationMessages[
                            'registration.join_sponsorship_failure.subheader'
                        ],
                        {
                            SupportLink: (...chunks: ReactNode[]) => (
                                <CHLink href={`mailto:${calmSupportEmail}`}>
                                    {chunks}
                                </CHLink>
                            ),
                        }
                    )}
                </Typography>
            </Box>
        </Stack>
    );
}

export default SsoSponsorshipError;
